// Calculate totals from lvs data recursively
export const calculateTotals = (elements) => {
	if (!elements) return { groups: 0, positions: 0, amount: 0 };

	let totalGroups = 0;
	let totalPositions = 0;
	let totalAmount = 0;

	elements.forEach((element) => {
		if (element.isGroup) {
			totalGroups += 1;
			const subTotals = calculateTotals(element.elements);
			totalGroups += subTotals.groups;
			totalPositions += subTotals.positions;
			totalAmount += subTotals.amount;
		} else {
			totalPositions += 1;
			totalAmount += element.totalPrice || element.totalPriceGross || 0;
		}
	});

	return {
		groups: totalGroups,
		positions: totalPositions,
		amount: totalAmount,
	};
};

// Get all group IDs recursively
export const getAllGroupIds = (elements) => {
	const groupIds = new Set();
	if (!elements) return groupIds;

	elements.forEach((element) => {
		if (element.isGroup) {
			groupIds.add(element.id);
			const subGroupIds = getAllGroupIds(element.elements);
			subGroupIds.forEach((id) => groupIds.add(id));
		}
	});

	return groupIds;
};
